export default class Constants {
  public static Pages = class {
    static home = '/';
    static changePassword = '/change-password';
    static changePasswordConfirm = '/change-password-confirm';
    static loggingTest = '/logging-test';
    static accessError = '/access-error';
    static technicalError = '/technical-error';
    static technicalErrorWithLogoff = '/technical-error-logoff';
    static notFound = '/not-found';
    static timeoutError = '/timeout-error';
    static logOff = '/log-off';
    static catchAll = '*';
  };

  public static UrlParameters = class {
    static clientID = 'client_id';
  };
}
